import React from 'react';
import '../less/prostor.less';
import hero_img from '../img/hero_img.webp';
import Hero from '../../../../auxiliary-components/shared/HeroBlock';
import AdditionalProduct from '../../../../auxiliary-components/shared/AdditionalProductBlock';
import QuestionsAdminNew from '../../../../auxiliary-components/shared/QuestionsAdminNew';
import FilesForDownloadNew from "../../../../auxiliary-components/shared/FilesForDownloadNew";
import TextAboveFooterNew from "../../../../auxiliary-components/shared/TextAboveFooterNew";
import CardOrderModal from '../../../../auxiliary-components/CardOrderModal';
import FAQStorybook from '@abank/abank-faq';
import { prostorCardTerms } from '../../../../services/urls/urls';
import CalculatorNew from '../../../../auxiliary-components/CalculatorNew';
import Tabs from '../../../../auxiliary-components/shared/Tabs';
import Tariffs from '../../../../auxiliary-components/shared/TariffsBlock';
import HowToBlockNew from '../../../../auxiliary-components/shared/HowToBlockNew';
import { Preloader } from 'MWComponents';
import { canUseDOM } from '../../../../helpers/canUseDOM';
import AdvantagesAdmin from '../../../../auxiliary-components/shared/AdvantagesBlockAdmin';
import additionalCards from '../enums/additional_cards_data.json';
import tariffs_data from '../enums/tariffs_data.json';
import hero_data from '../enums/hero_data.json';
import { filterByEnvironment } from '../../../../helpers/utils/environmentFilter';
import { howToGetCardItems } from '../../enums/howToGetCardData';

export default function template() {
    const model = this.getModel();

    const tabs = [{tab: 'tariffs', title: 'PROSTOR_CARD_TABS_TITLE_01'},
          {tab: 'calculator', title: 'PROSTOR_CARD_TABS_TITLE_02'},
          {tab: 'how-to-get-card', title: 'CARDS_COMMON_NEW_HOW_TO_GET_CARD_TAB_TITLE'}];

    const handlersMap = {
      scrollToFaq: this.scrollToFrequentlyAskedQuestions,
      toggleHeroModal: this.toggleModal,
    };

    const tariffsData = tariffs_data.map(item => {
      if (typeof item.label === 'object' && item.label.link.onClick) {
        return {
          ...item,
          label: {
            ...item.label,
            link: {
              ...item.label.link,
              onClick: handlersMap[item.label.link.onClick],
            },
          },
        };
      }

      return item;
    });

    const heroData = {
      ...hero_data,
      link: {
        ...hero_data.link,
        onClick: handlersMap[hero_data.link.onClick],
      },
    };

    const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

    return (
        <div className="module-prostor">
          <Hero
            data={heroData}
            img={hero_img}
          />
          <div className={`content${this.state.faqTab ? ' hidden' : ''}`}>
            <AdvantagesAdmin
              data={this.widgetsHelper.getWidget.call(this, 'green_text_block')}
              loader={this.state.loader}
            />
            <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab} isMobile={this.state.isMobile}>
              <Tariffs
                items={tariffsData}
                title={'PROSTOR_CARD_CARDS_TARIFFS_TITLE'}
                btnLink={prostorCardTerms}
                btnText={'PROSTOR_CARD_CARDS_TARIFFS_BTN'}
                text={'PROSTOR_CARD_CARDS_TARIFFS_TEXT'}
              />
              {model.creditSum ? (
                <CalculatorNew model={model} type="credit_cards" {...this.props}/>
              ) : (canUseDOM ? <Preloader /> : null)}
              <HowToBlockNew
                title={'CARDS_COMMON_NEW_HOW_TO_GET_CARD_TITLE'}
                items={howToGetCardItems}
              />
            </Tabs>
            <AdditionalProduct
              items={additionalCards}
              title={'PROSTOR_CARD_ADDITIONAL_PRODUCT_TITLE'}
            />
            <QuestionsAdminNew
              widget={questionsWidget}
              toggleFaqTab={this.toggleFaqTab}
              title={'PROSTOR_CARD_QUESTIONS_TITLE'}
              loader={this.state.loader}
            />
            <FilesForDownloadNew
              lang={this.props.lang}
              widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
            />
            <TextAboveFooterNew
              widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')}
            />
          </div>
          <div className={`content${!this.state.faqTab ? ' hidden' : ''}`}>
            <FAQStorybook
              widget={questionsWidget}
              title={this.l10n('PROSTOR_CARD_FAQ_STORYBOOK_TITLE')}
              btnText={this.l10n('PROSTOR_CARD_FAQ_STORYBOOK_BTN_TEXT')}
              onBtnClick={this.toggleFaqTab}
              filterByEnvironment={filterByEnvironment}
            />
          </div>
          {this.state.showModal && <CardOrderModal closeModal={this.toggleModal} product={"prostor"} isOpen={this.state.showModal}/>}
        </div>
    );
}
